//Authentication
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import MainLayout from "../Hoc/MainLayout";
import SnackBar from "../components/SnackBar";
import Login from "../containers/login";

//Genomics CE Admin
import GenomicsDash from "../containers/GenomicsCustomerExecutive-agent";
import GenomicsHomePage from "../GenomicsCustomeExecutive-Panel/Pages/Home";
import GenomicsBookingpage from "../GenomicsCustomeExecutive-Panel/Components/Bookings/BookingPage";
import GenomicsNewBooking from "../GenomicsCustomeExecutive-Panel/Components/Bookings/NewBooking/GenomicsNewBooking";
import GenViewBooking from "../GenomicsCustomeExecutive-Panel/Components/Bookings/ViewBooking";
import GenEditBookingForm from "../GenomicsCustomeExecutive-Panel/Components/Bookings/EditBookingForm/EditBookingForm";
import GenAddAditionalFamily from "../GenomicsCustomeExecutive-Panel/Components/Bookings/NewBooking/AddFamilyMember";
import GenTatTimeBookingtable from "../GenomicsCustomeExecutive-Panel/Pages/tatTimeBookingFilter";
import GenTRF from "../GenomicsCustomeExecutive-Panel/Components/Bookings/DownloadBooking/Tablemy";
import GenFilterPage from "../GenomicsCustomeExecutive-Panel/Pages/filter";
import GenCenterCreation from "../GenomicsCustomeExecutive-Panel/Pages/Center-Creation/index";
import GenomicsReportStatus from "../GenomicsCustomeExecutive-Panel/Pages/ReportStatus";

//Genomics Phlebo Admin
import GenomicsPhaDash from "../containers/GenomicsPhleboAdmin-agent";
import GenomicsPhaHomePage from "../GenomicsPhleboAdmin-Panel/Pages/Home";
import GenomicsPhaBookingpage from "../GenomicsPhleboAdmin-Panel/Components/Bookings/BookingPage";
import GenomicsPhaNewBooking from "../GenomicsPhleboAdmin-Panel/Components/Bookings/NewBooking/GenomicsNewBooking";
import GenPhaViewBooking from "../GenomicsPhleboAdmin-Panel/Components/Bookings/ViewBooking/index";
import GenPhaEditBookingForm from "../GenomicsPhleboAdmin-Panel/Components/Bookings/EditBookingForm/EditBookingForm";
import GenPhaAddAditionalFamily from "../GenomicsPhleboAdmin-Panel/Components/Bookings/NewBooking/AddFamilyMember";
import GenPhaTatTimeBookingtable from "../GenomicsPhleboAdmin-Panel/Pages/tatTimeBookingFilter";
import GenPhaFilterPage from "../GenomicsPhleboAdmin-Panel/Pages/filter";
import GenPhaBookingCard from "../GenomicsPhleboAdmin-Panel/Components/Bookings/BookingCard";
import GenPhaTRF from "../GenomicsPhleboAdmin-Panel/Components/Bookings/DownloadBooking/Trf";
import GenViewBookingOnMap from "../GenomicsPhleboAdmin-Panel/Components/Bookings/BookingCard/ViewBookingOnMap"
import GENPhaManagePhlebo from '../GenomicsPhleboAdmin-Panel/Tables/managePhlebos';
import GENPhaAttendanceManagePhlebo from '../GenomicsPhleboAdmin-Panel/Components/ManageAttendance/index'

// Genom IT Dash 
import GenomDash from "../containers/GenomTracker-agent";
import GenomDashHome from "../GenomTracker-Panel/pages/Home/home";
import GenomDashHomeTest from "../GenomTracker-Panel/pages/test";



// Genomics Sample accessioning panel
import GenSampleAccessioningDash from "../containers/GenomicsSampleAccessioning-agent/index";
import GenSampleAccessioningFilterPage from "../GenomicsSampleAccessioning-Panel/pages/filter";
import GenSampleAccessioningViewBooking from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/index";
import GenSampleAccessioningEditBookingForm from "../GenomicsSampleAccessioning-Panel/components/Bookings/EditBookingForm/EditBookingForm";
import GenSampleAccessioningDownload from "../GenomicsSampleAccessioning-Panel/components/Bookings/DownloadBooking/Trf";
import GenSAComplaintsBooking from "../GenomicsSampleAccessioning-Panel/tables/queryTicketsBooking";
import GenSampleAccCenterInfo from "../GenomicsSampleAccessioning-Panel/tables/centerTable";
import GenSAInbox from "../GenomicsSampleAccessioning-Panel/components/notificationInbox/index";
import GenSampleHandOver from '../GenomicsSampleAccessioning-Panel/tables/sampleHandOverTable'
import GenSampleAccessioningTestPackages from "../GenomicsSampleAccessioning-Panel/pages/testPackages";
import GenSampleUnregisterBooking from '../GenomicsSampleAccessioning-Panel/tables/unregisterdBooking';
import GenBiomarkerScreening from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/BiomarkerScreeningreport";
import GenNpisForm from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/NPIS"
import GenExomeSequencing from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/exome_sequencing";
import GenCytogenetics from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/trf_cytogenetics";
import GenUploadTrf from "../GenomicsSampleAccessioning-Panel/components/Bookings/ViewBooking/trfUpload";
import GenSaHome from "../GenomicsSampleAccessioning-Panel/pages/home";

//Genomics Admin panel
import GenomicsAdminPanelAgentDash from "../containers/GenomicsAdminPanel-agent/index";
import GenomicsAdminBookingPage from "../GenomicsAdmin-Panel/Components/Bookings/BookingPage";
import GenomicsAdminViewBooking from "../GenomicsAdmin-Panel/Components/Bookings/ViewBooking/index";
import GenomicsAdminEditBookingForm from "../GenomicsAdmin-Panel/Components/Bookings/EditBookingForm/EditBookingForm";
import GenomicsAdminFilterPage from "../GenomicsAdmin-Panel/Pages/filter";
import GenomicsAdminAdvancePayment from "../GenomicsAdmin-Panel/Tables/advancePayment";
import GenomicsAdminCCClientLedgerDetails from "../GenomicsAdmin-Panel/Tables/ccClientLedgerDetails";
import GenomicsAdminRateList from "../GenomicsAdmin-Panel/Tables/RateList";
import GenomicsAdminCenterCreation from "../GenomicsAdmin-Panel/Pages/Center-Creation";
import GenomicsAdminViewPackage from "../GenomicsAdmin-Panel/Pages/ViewPackage/index";
import GenomicsAdminReportStatus from "../GenomicsAdmin-Panel/Pages/ReportStatus/index";
import GenomicsAdminSalesSummary from "../GenomicsAdmin-Panel/Pages/SalesSummary/index";
import GenomicsAdminCentreCampPackage from "../GenomicsAdmin-Panel/Pages/CentreCampPackage/index";
import GenomicsAdminPromotionalCampaign from "../GenomicsAdmin-Panel/Pages/PromotionalCamp/index";
import GenomicsAdminNewRateList from "../GenomicsAdmin-Panel/Pages/RateList/newRateList";
import GenomicsAdminCCInvoice from "../GenomicsAdmin-Panel/Pages/CcInvoice/index";
import GenomicsAdminInvoiceBreakup from "../GenomicsAdmin-Panel/Components/CcPdf/invoiceBreakup";
import GenomicsAdminInvoicePdf from "../GenomicsAdmin-Panel/Components/CcPdf/invoicePdf";
import GenomicsAdminBillPdf from "../GenomicsAdmin-Panel/Components/BillPdf/index";
import GenomicsAdminExportCCLedger from "../GenomicsAdmin-Panel/Components/LedgerExport/index";
import GenomicsAdminTatMaster from "../GenomicsAdmin-Panel/Pages/TatMaster/index";
import GenomicsAdminCentreLabOrg from "../GenomicsAdmin-Panel/Pages/CentreLabOrg/index";
import GenomicsAdminRecharge from "../GenomicsAdmin-Panel/Pages/Recharge/index";
import GenomicsAdminBookingTicket from "../GenomicsAdmin-Panel/Tables/queryTicketsBooking";
import GenomicsAdminCreateUsers from "../GenomicsAdmin-Panel/Pages/CreateUsers";
import GenomicsAdminEmployeeMaster from "../GenomicsAdmin-Panel/Pages/EmployeeMaster/index";
import GenomicsAdminAddDoctor from "../GenomicsAdmin-Panel/Pages/doctorCreation";


// Genomics Genomics Research Panel GenomicsCenterHospital
import GenomicsResearchAcessioningRoutes from "../GenomicsResearch-Panel/Routes"
// Genomics Research Lab
import GenomicsResearchLabRoutes from "../Genomics/Research/Routes";
import { useUser } from "../providers/user";
import { NewDash } from "../containers/dash/newDash";

function Routes() {
  const user = useUser();
  return (
    <BrowserRouter>
      <MainLayout>
        <SnackBar />
        <Switch>
          <Route path="/" exact component={user.profile ? NewDash : Login} />
          {user.profile ?
            <Switch>
              <Route
                path="/dashboard/gce"
                exact={false}
                component={() => {
                  return (
                    <Switch>
                      <GenomicsDash>
                        <Route
                          path="/dashboard/home"
                          exact
                          component={GenomicsHomePage}
                        />
                        <Route
                          path="/dashboard/gce/bookingpage"
                          exact
                          component={GenomicsBookingpage}
                        />
                        <Route
                          path="/dashboard/gce/genomicsnewbooking"
                          exact
                          component={GenomicsNewBooking}
                        />
                        <Route
                          path="/dashboard/gce/booking-view/:id"
                          exact
                          component={GenViewBooking}
                        />
                        <Route
                          exact
                          path="/dashboard/gce/tat_timeBooking"
                          component={GenTatTimeBookingtable}
                        />
                        <Route
                          exact
                          path="/dashboard/gce/trf"
                          component={GenTRF}
                        />
                        <Route
                          path="/dashboard/gce/booking-edit/:id/edit"
                          exact
                          component={GenEditBookingForm}
                        />
                        <Route
                          path="/dashboard/gce/booking-additionalFamily/:id/add"
                          exact
                          component={GenAddAditionalFamily}
                        />
                        <Route
                          path="/dashboard/gce/centerCreationModal"
                          exact
                          component={GenCenterCreation}
                        />
                        <Route
                          path="/dashboard/gce/report_status"
                          exact
                          component={GenomicsReportStatus}
                        />
                        <Route
                          path="/dashboard/gce"
                          exact
                          component={GenFilterPage}
                        />
                      </GenomicsDash>
                    </Switch>
                  );
                }}
              />

              <Route
                path="/dashboard/gsa"
                exact={false}
                component={() => {
                  return (
                    <Switch>
                      <GenSampleAccessioningDash>
                        <Route
                          exact
                          path="/dashboard/gsa"
                          component={GenSaHome}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/booking_list"
                          component={GenSampleAccessioningFilterPage}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/booking-view/:id"
                          component={GenSampleAccessioningViewBooking}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/booking-edit/:id/edit"
                          component={GenSampleAccessioningEditBookingForm}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/download/:id/download"
                          component={GenSampleAccessioningDownload}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/booking/tickets"
                          component={GenSAComplaintsBooking}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/centerInfo"
                          component={GenSampleAccCenterInfo}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/inbox"
                          component={GenSAInbox}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/SampleHandOver"
                          component={GenSampleHandOver}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/testPackages"
                          component={GenSampleAccessioningTestPackages}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/unregister-booking"
                          component={GenSampleUnregisterBooking}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/sampleaccessiong-BiomarkerScreeningreport/:id"
                          component={GenBiomarkerScreening}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/NpisForm/:id"
                          component={GenNpisForm}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/ExomeSequencing/:id"
                          component={GenExomeSequencing}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/Cytogenetics/:id"
                          component={GenCytogenetics}
                        />
                        <Route
                          exact
                          path="/dashboard/gsa/uploadTrf/:id"
                          component={GenUploadTrf}
                        />
                      </GenSampleAccessioningDash>
                    </Switch>
                  );
                }}
              />

              <Route
                path="/dashboard/gnrelab"
                exact={false}
                component={GenomicsResearchLabRoutes}
              />

              <Route
                path="/dashboard/gnadmin"
                exact={false}
                component={() => {
                  return (
                    <Switch>
                      <GenomicsAdminPanelAgentDash>

                        <Route
                          path="/dashboard/gnadmin"
                          exact
                          component={GenomicsAdminFilterPage}
                        />
                        <Route
                          path="/dashboard/gnadmin/recharge"
                          exact
                          component={GenomicsAdminRecharge}
                        />
                        <Route
                          path="/dashboard/gnadmin/booking/tickets"
                          exact
                          component={GenomicsAdminBookingTicket}
                        />
                        <Route
                          path="/dashboard/gnadmin/create-users"
                          exact
                          component={GenomicsAdminCreateUsers}
                        />
                        <Route
                          path="/dashboard/gnadmin/employee_master"
                          exact
                          component={GenomicsAdminEmployeeMaster}
                        />
                        <Route
                          path="/dashboard/gnadmin/booking"
                          exact
                          component={GenomicsAdminBookingPage}
                        />
                        <Route
                          path="/dashboard/gnadmin/booking-view/:id"
                          exact
                          component={GenomicsAdminViewBooking}
                        />
                        <Route
                          path="/dashboard/gnadmin/view_package"
                          exact
                          component={GenomicsAdminViewPackage}
                        />
                        <Route
                          path="/dashboard/gnadmin/booking-edit/:id/edit"
                          exact
                          component={GenomicsAdminEditBookingForm}
                        />
                        <Route
                          path="/dashboard/gnadmin/AdvancePayment"
                          exact
                          component={GenomicsAdminAdvancePayment}
                        />
                        <Route
                          path="/dashboard/gnadmin/tat_master"
                          exact
                          component={GenomicsAdminTatMaster}
                        />
                        <Route
                          path="/dashboard/gnadmin/ccClientLedgerDetails"
                          exact
                          component={GenomicsAdminCCClientLedgerDetails}
                        />
                        <Route
                          path="/dashboard/gnadmin/ratelist"
                          exact
                          component={GenomicsAdminRateList}
                        />
                        <Route
                          path="/dashboard/gnadmin/centerCreationModal"
                          exact
                          component={GenomicsAdminCenterCreation}
                        />
                        <Route
                          path="/dashboard/gnadmin/centre_lab_org"
                          exact
                          component={GenomicsAdminCentreLabOrg}
                        />
                        <Route
                          path="/dashboard/gnadmin/new_rate_list"
                          exact
                          component={GenomicsAdminNewRateList}
                        />
                        <Route
                          path="/dashboard/gnadmin/promotional_campaign"
                          exact
                          component={GenomicsAdminPromotionalCampaign}
                        />
                        <Route
                          path="/dashboard/gnadmin/cc_invoice"
                          exact
                          component={GenomicsAdminCCInvoice}
                        />
                        <Route
                          path="/dashboard/gnadmin/cc_invoice_breakup"
                          exact
                          component={GenomicsAdminInvoiceBreakup}
                        />
                        <Route
                          path="/dashboard/gnadmin/cc_invoice_pdf"
                          exact
                          component={GenomicsAdminInvoicePdf}
                        />
                        <Route
                          path="/dashboard/gnadmin/report_status"
                          exact
                          component={GenomicsAdminReportStatus}
                        />
                        <Route
                          path="/dashboard/gnadmin/sales_summary"
                          exact
                          component={GenomicsAdminSalesSummary}
                        />
                        <Route
                          path="/dashboard/gnadmin/centre_camp_package"
                          exact
                          component={GenomicsAdminCentreCampPackage}
                        />

                        {/* <Route
                            path="/dashboard/ccadmin/cc_transaction_history"
                            exact
                            component={CCAdminTransactionHistory}
                          /> */}
                        <Route
                          path="/dashboard/gnadmin/cc_bill_pdf"
                          exact
                          component={GenomicsAdminBillPdf}
                        />
                        <Route
                          path="/dashboard/gnadmin/cc_Ledger_export"
                          exact
                          component={GenomicsAdminExportCCLedger}
                        />
                        <Route
                          path="/dashboard/gnadmin/addDoctor"
                          exact
                          component={GenomicsAdminAddDoctor}
                        />
                      </GenomicsAdminPanelAgentDash>
                    </Switch>
                  );
                }}
              />

              <Route
                path="/dashboard/gnre"
                exact={false}
                component={GenomicsResearchAcessioningRoutes}
              />

              <Route
                path="/dashboard/gpha"
                exact={false}
                component={() => {
                  return (
                    <Switch>
                      <GenomicsPhaDash>
                        <Route
                          path="/dashboard/home"
                          exact
                          component={GenomicsPhaHomePage}
                        />
                        <Route
                          path="/dashboard/gpha/bookingpage"
                          exact
                          component={GenomicsPhaBookingpage}
                        />
                        <Route
                          path="/dashboard/gpha/genomicsnewbooking"
                          exact
                          component={GenomicsPhaNewBooking}
                        />
                        <Route
                          path="/dashboard/gpha/booking-view/:id"
                          exact
                          component={GenPhaViewBooking}
                        />
                        <Route
                          exact
                          path="/dashboard/gpha/tat_timeBooking"
                          component={GenPhaTatTimeBookingtable}
                        />
                        <Route
                          path="/dashboard/gpha/booking-edit/:id/edit"
                          exact
                          component={GenPhaEditBookingForm}
                        />
                        <Route
                          path="/dashboard/gpha/booking-additionalFamily/:id/add"
                          exact
                          component={GenPhaAddAditionalFamily}
                        />
                        <Route
                          path="/dashboard/gpha"
                          exact
                          component={GenPhaFilterPage}
                        />
                        <Route
                          exact
                          path="/dashboard/gpha/view-booking-on-map"
                          component={GenViewBookingOnMap}
                        />
                        <Route
                          path="/dashboard/gpha/bookingCard"
                          exact
                          component={GenPhaBookingCard}
                        />

                        <Route
                          path="/dashboard/gpha/download/:id/download"
                          exact
                          component={GenPhaTRF}
                        />
                        <Route
                          exact
                          path="/dashboard/gpha/phlebo"
                          component={GENPhaManagePhlebo}
                        />
                        <Route
                          exact
                          path="/dashboard/gpha/attendance"
                          component={GENPhaAttendanceManagePhlebo}
                        />
                      </GenomicsPhaDash>
                    </Switch>
                  );
                }}
              />
              <Route
                path="/dashboard/genom"
                exact={false}
                component={() => {
                  return (
                    <Switch>
                      <GenomDash>
                        <Route
                          path="/dashboard/genom/home"
                          exact
                          component={GenomDashHome}
                        />
                        <Route
                          path="/dashboard/genom/test"
                          exact
                          component={GenomDashHomeTest}
                        />
                      </GenomDash>
                    </Switch>
                  );
                }}
              />
            </Switch>
            : null
          }
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </MainLayout>
    </BrowserRouter>
  );
}
export default Routes;